module.exports = __webpack_public_path__ + "81ff044ea52ac8b11e633d9a31c2809b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2_2023_chart.png
// module id = 1658
// module chunks = 0